import { render, staticRenderFns } from "./EmailNotificationsSettingsCard.vue?vue&type=template&id=18f138c1&"
import script from "./EmailNotificationsSettingsCard.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationsSettingsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports